<template lang="pug">
    article#faq
        Banner(nomePagina="FAQ")
        Conteudo
        Inscricao
</template>

<script>
import Banner from '@components/BannerTemplates/BannerTemplates.vue'
import Conteudo from '@sections/Faq/Conteudo/Conteudo.vue'
import Inscricao from '@components/Inscricao/Inscricao.vue'
import pagina from '@/mixins/pagina'

export default {
    name: "view-faq",
    components: {
        Banner, 
        Conteudo,
        Inscricao
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./Faq.styl"></style>